import ComponentStyle from '../ComponentStyle'

/**
 * Type === h1, h2, h3, h4, h5, h6
 */
export default function ComponentBlocksHeadline ({ Text, Type, FontSize }) {
  return (
    <div className="col">
      <ComponentStyle config={{
        FontSize
      }}
      >
        <Type className="text-dark">{Text}</Type>
      </ComponentStyle>
    </div>
  )
}
